import useCreateTaskBrio from '../mutations/useCreateTaskBrio';
import useExportPartyToBrio from '../mutations/useExportPartyToBrio';
import useUploadDocumentBrio from '../mutations/useUploadDocumentBrio';

export default function useActionsBrio() {
  const { mutateAsync: createTask } = useCreateTaskBrio();
  const { mutateAsync: exportParty } = useExportPartyToBrio();
  const { mutateAsync: uploadDocument } = useUploadDocumentBrio();

  return {
    createTask,
    exportParty,
    uploadDocument,
  };
}
